import { Directive, TemplateRef, inject } from "@angular/core";
import { AlertItem } from "./alert-list.component";

export type AlertItemTemplateContext = {
    $implicit: AlertItem;
};

@Directive({
    selector: "ng-template[raskAlertItem]",
    standalone: true
})
export class AlertItemTemplateDirective {
    readonly templateRef = inject<TemplateRef<AlertItemTemplateContext>>(TemplateRef);

    static ngTemplateContextGuard(
        _directive: AlertItemTemplateDirective,
        context: unknown
    ): context is AlertItemTemplateContext {
        return true;
    }
}
